<template>
  <div class="index">
    <!-- head -->
    <div class="head" id="head">
      <img src="../../static/images/banner.png" alt="img" class="headImg" />
      <div class="headNav">
        <div class="container">
          <div class="headNavC">
            <a href="#" class="headNavClogo">
              <img src="../../static/images/logo.png" alt="logo" />
            </a>
            <ul class="headNavClist">
              <li :class="{ on: broadsideOn == 'head' }" @click="goRule('head')">
                <a href="javascript:;">首页</a>
                <span></span>
              </li>
              <li :class="{ on: broadsideOn == 'about' }" @click="goRule('about')">
                <a href="javascript:;">了解我们</a>
                <span></span>
              </li>
              <li :class="{ on: broadsideOn == 'customer' }" @click="goRule('customer')">
                <a href="javascript:;">客户服务</a>
                <span></span>
              </li>
              <li
                :class="{ on: broadsideOn == 'cooperation' }"
                @click="goRule('cooperation')"
              >
                <a href="javascript:;">合作伙伴</a>
                <span></span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- 了解我们 安全保障 -->
    <div class="about" id="about">
      <div class="container">
        <img src="../../static/images/about1.png" alt="img" />
        <img src="../../static/images/about2.png" alt="img" />
      </div>
    </div>
    <!-- 客户服务 -->
    <div class="customer" id="customer">
      <img src="../../static/images/customer1.png" alt="img" class="customerImg" />
      <div class="customerC">
        <div class="customerCtext">
          <h4>在楹枣花，我们始终将您的<span>需求和体验</span>放在首位</h4>
          <p>
            通过专业化的人工客服团队、先进的技术赋能，打造多元化的客户服务体系，为您提<br />供更高效和贴心的服务、如有任何疑问，下载APP获得专属客户服服务
          </p>
        </div>
        <div class="customerCbtn">
          点我下载APP
          <img
            src="../../static/images/customer2.png"
            alt="img"
            class="customerCbtnIcon"
          />
          <img
            src="../../static/images/customer3.png"
            alt="img"
            class="customerCbtnCode"
          />
        </div>
      </div>
    </div>
    <!-- 合作伙伴 -->
    <div class="cooperation" id="cooperation">
      <div class="container">
        <img src="../../static/images/cooperation.png" alt="img" />
      </div>
    </div>
    <!-- foot -->
    <div class="foot">
      <div class="footC">
        <div class="footL">
          <a href="javascript:;" class="footLlogo">
            <img src="../../static/images/logo.png" alt="logo" />
          </a>
          <div class="footLT">
            <p>公司名称：南京市三六五互联网科技小额贷款有限公司</p>
            <p>备案信息：苏ICP备2023041199号-9</p>
            <p>出资方：南京市三六五互联网科技小额贷款有限公司</p>
            <p>地址：江苏省南京市建区江东中路258号3幢华新城经营范围T1写字楼3235室</p>
          </div>
        </div>
        <div class="footR">
          <img src="../../static/images/footR1.png" alt="img" />
          <img src="../../static/images/footR2.png" alt="img" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      broadsideOn: "head",
    };
  },
  mounted() {},
  methods: {
    //导航
    goRule(event) {
      this.broadsideOn = event;
      var id = "#" + event;
      document.querySelector(id).scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/index.vue